// @ts-nocheck
import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  Validator,
} from '@angular/forms';

type inputType =
  | 'text'
  | 'number'
  | 'currency'
  | 'email'
  | 'password'
  | 'search'
  | 'tel'
  | 'url'
  | 'color'
  | 'date'
  | 'datetime-local'
  | 'time'
  | 'month'
  | 'week';

@Component({
  selector: 'lib-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InputComponent),
      multi: true,
    },
  ],
  exportAs: 'libInput',
})
export class InputComponent implements ControlValueAccessor, Validator {
  @ViewChild('input', { static: true }) input: ElementRef<HTMLInputElement>;

  @Input()
  set type(value: inputTyle) {
    this._isCurrency = value === 'currency';
    this._type = this._isCurrency
      ? 'text'
      : value;
  }

  @Input()
  set theme(theme: 'primary' | 'warn') {
    this._class = `lib-input${theme ? `-${theme}` : ''}`;
  }

  @Input() autocomplete = false;

  @Input() placeholder: string;

  @Input() list: string;

  @Input() prefixIcon: string;

  @Input() suffixIcon: string;

  @Input()
  set value(value: any) {
    this.writeValue(value);
  }

  @Input()
  set disabled(value: string | boolean) {
    this.setDisabledState(value === '' || value === 'true' || value === true);
  }

  @Input() testAttribute: string | null = null;

  @Output() update: EventEmitter<any> = new EventEmitter();

  _value: any = '';

  _type: inputTyle = 'text';

  _isCurrency: boolean;

  _class: string = 'lib-input';

  private data: any;

  constructor(private renderer: Renderer2) { }

  writeValue(data: any): void {
    this.data = data;
    if (this._isCurrency) {
      this._value = data ? this.formatCurrency(data) : '';
    } else {
      this._value = data || '';
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void { }

  setDisabledState(isDisabled: boolean) {
    this.renderer.setProperty(this.input?.nativeElement, 'disabled', isDisabled);
  }

  onChange(event: Event) {
    const inputElement: HTMLInputElement = event?.target as HTMLInputElement;
    const value = inputElement.value;

    if (this._isCurrency) {
      this.data = Number(value.replace(/,/g, ''));
      this._value = this.data ? this.formatCurrency(this.data) : '';
    } else {
      this.data = value;
      this._value = this.data || '';
    }

    this.propagateChange(this.data);

    this.update.emit(this.data);
  }

  validate(control: AbstractControl): { [key: string]: any } | null {
    // return control.errors;
    return null;
  }

  preventIlegalCharacters(event: KeyboardEvent): void {
    if (this._isCurrency
      && !(
        (event.key >= '0' && event.key <= '9') // if number
        || event.key === 'Enter' || event.key === 'Backspace') // if allowd keys
    ) {
      event.preventDefault();
    }
  }

  private propagateChange = (_: any) => { };

  private formatCurrency(value: number): string {
    return new Intl.NumberFormat('en-GB')
      .format(value);
  }
}
